export default __webpack_public_path__ + "static/media/search-clear-icon.00573944.svg";